import React, { useEffect, useState } from "react";
import { ReactMultiEmail } from "react-multi-email";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { EMAIL_PATTERN_REGEX, INVITE_TYPE } from "../../../../../constants/InviteConstants";
import { PublicVariables } from "../../../../../constants/PublicVariables";

const EmailBox = ({ index, email, removeEmail }) => {
    return (
        <div data-tag className='email-id'>
            <div data-tag-item className='email-id-text'>
                {email}
            </div>
            <button data-tag-handle className='btn remove-email-btn' onClick={() => removeEmail(index)}>
                <span className='btn-icon icon-close'></span>
            </button>
        </div>
    );
};

const EmailTab = ({
    privacyPolicyData,
    inviteUrl,
    emails,
    setEmails,
    localisedValues,
    handleSendInvite,
    inviteParticipantLoading,
    isDoneBtnVisible,
    handleCloseModal,
    isSentBtnVisible,
}) => {
    const { joinMeetingSmsTemplate } = useSelector((state) => state.inviteParticipant);

    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isEmailFieldFocused, setIsEmailFieldFocused] = useState(false);
    const [emailTemplate, setEmailTemplate] = useState("");
    const [isSendBtnDisabled, setIsSendBtnDisabled] = useState(true);

    useEffect(() => {
        let template = localisedValues.has_sent_you_link_for_video_conference;
        template = template.replace("<company_name>", privacyPolicyData.domainName);

        if (joinMeetingSmsTemplate) {
            template = joinMeetingSmsTemplate;
        }
        setEmailTemplate(template);
    }, [joinMeetingSmsTemplate]);

    const onEmailChangeHandler = (value) => {
        const updatedValue = value?.replace(",", "")?.trim();
        const isValidEmailId = updatedValue ? emailRegex.test(updatedValue) : emails.length > 0;

        setIsSendBtnDisabled(!isValidEmailId);
        setIsValidEmail(true);

        if (value === "" && emails.length !== 0) {
            setIsSendBtnDisabled(false);
        }
    };

    const handleGenratePayload = () => {
        const payload = {
            invitationType: INVITE_TYPE.EMAIL,
            emailAddress: emails.join(),
        };
        handleSendInvite(payload);
    };

    const emailRegex = new RegExp(EMAIL_PATTERN_REGEX);

    return (
        <div className='tab-pane active' id='invite-email' role='tabpanel' aria-labelledby='invite-email-tab' data-testid='invite-email-tab'>
            <div className='invite-participant'>
                <div className='invite-participant-box'>
                    <div className='invite-title-mobile'>
                        <h3>{localisedValues.email}</h3>
                    </div>
                    <div className='invite-title-desktop'>
                        <h3>{localisedValues.enter_email_send}</h3>
                    </div>
                    <div className='invite-participant-form'>
                        <div className='form-group'>
                            <div className='form-group-in'>
                                <ReactMultiEmail
                                    id='emailInput'
                                    placeholder={localisedValues.new_email_address}
                                    emails={emails}
                                    autoFocus={true}
                                    className='multiple-email default-custom-scroll-thin'
                                    onChange={(_emails) => {
                                        setEmails(_emails);
                                    }}
                                    onChangeInput={onEmailChangeHandler}
                                    validateEmail={(email) => {
                                        setIsValidEmail(emailRegex.test(email));
                                        setIsSendBtnDisabled(!emailRegex.test(email));
                                        return emailRegex.test(email);
                                    }}
                                    onFocus={() => {
                                        setIsEmailFieldFocused(true);
                                    }}
                                    onBlur={() => setIsEmailFieldFocused(false)}
                                    getLabel={(email, index, removeEmail) => (
                                        <EmailBox key={email + "_" + index} email={email} index={index} removeEmail={removeEmail} />
                                    )}
                                    style={{ fontSize: PublicVariables.isIOSDevice ? "16px" : "" }}
                                />
                            </div>
                            {!isEmailFieldFocused && !isValidEmail && <div className='validation-error'>{localisedValues.enter_valid_email}</div>}
                        </div>
                        <div className='form-group'>
                            <div className='email-invitation-msg'>
                                <div className='email-invitation-bar'>{emailTemplate}</div>
                                <div className='email-invitation-bar'>
                                    <a className='text-dec-none' href={inviteUrl} target='_blank'>
                                        {inviteUrl}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isSentBtnVisible && (
                        <div className='send-success'>
                            <span className='for-icon icon-checked-fill-bold'></span>
                            <span className='for-text'>{localisedValues.email_sent_label}</span>
                        </div>
                    )}
                </div>
                <div className='invite-participant-footer'>
                    <div className='button-inline more-space d-flex justify-content-end align-items-center'>
                        {isDoneBtnVisible && (
                            <div className='button'>
                                <button type='button' className='btn btn-link default-btn-link' onClick={handleCloseModal}>
                                    {localisedValues.done}
                                </button>
                            </div>
                        )}
                        <div className='button'>
                            <button
                                type='button'
                                className='btn btn-primary btn-with-icon default-btn-primary'
                                data-testid='sendInvitationBtn'
                                onClick={handleGenratePayload}
                                disabled={isSendBtnDisabled || inviteParticipantLoading || isEmpty(emails)}
                            >
                                {inviteParticipantLoading && (
                                    <span className='btn-loader-icon'>
                                        <span className='for-icon icon-loader spin'></span>
                                    </span>
                                )}
                                {localisedValues.send_invitaion_lable}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

EmailBox.propTypes = {
    index: PropTypes.any,
    email: PropTypes.string,
    removeEmail: PropTypes.func,
};

EmailTab.propTypes = {
    privacyPolicyData: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    inviteUrl: PropTypes.string,
    emails: PropTypes.array,
    setEmails: PropTypes.func,
    localisedValues: PropTypes.object,
    handleSendInvite: PropTypes.func,
    inviteParticipantLoading: PropTypes.bool,
    isDoneBtnVisible: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    isSentBtnVisible: PropTypes.bool,
};

export default EmailTab;
